import { render } from "./PrintInfoBlock.vue?vue&type=template&id=18bb7018&scoped=true"
import script from "./PrintInfoBlock.vue?vue&type=script&lang=js"
export * from "./PrintInfoBlock.vue?vue&type=script&lang=js"

import "./PrintInfoBlock.vue?vue&type=style&index=0&id=18bb7018&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bb7018"]])

export default __exports__